import { z } from "zod";

export const campaignStatusEnum = z.enum(["PENDING", "ACTIVE", "FINISHED"]);

export type CampaignStatus = z.infer<typeof campaignStatusEnum>;
